export const requestInstance = async <T>(
	url: string,
	data: T,
	method: string,
	signal?: AbortSignal,
	token?: string,
) => {
	const axios = (await import('axios')).default;

	if (token) {
		return await axios({
			method,
			url,
			data,
			signal,
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
	}

	return await axios({
		method,
		url,
		data,
		signal,
	});
};
